import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./app";
import { applyTheme } from "./lib/theme";
import { missingEnv } from "./lib/env";

applyTheme();
const root = createRoot(document.getElementById("root")!);
if (missingEnv.length) {
  root.render(
    <div style={{ padding: 32, fontFamily: "system-ui" }}>
      <h1>Yapılandırma eksik</h1>
      <p>
        apps/admin/.env dosyasında şunlar tanımlı olmalı: {missingEnv.join(", ")} (bkz.
        .env.example).
      </p>
    </div>,
  );
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
